"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { ExploreWaveCard } from "./ExploreWaveCard";
import { ExploreWaveCardSkeleton } from "./ExploreWaveCardSkeleton";
const WAVES_LIMIT = 6;
export function ExploreWavesSection() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["explore-waves-homepage", WAVES_LIMIT],
      queryFn: _temp,
      staleTime: 300000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: waves,
    isLoading,
    isError
  } = useQuery(t0);
  if (isError) {
    return null;
  }
  if (!isLoading && (!waves || waves.length === 0)) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><span className="tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-white md:tw-text-2xl">Explore waves</span><p className="tw-mb-0 tw-mt-2 tw-text-base tw-text-iron-500">Browse channels—jump into the conversation.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-mb-8 tw-flex tw-flex-col tw-items-start tw-gap-4 sm:tw-flex-row sm:tw-items-end sm:tw-justify-between">{t1}<Link href="/waves" className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-400 tw-no-underline tw-transition-colors hover:tw-text-white"><span>View all</span><ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" aria-hidden={true} /></Link></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isLoading || $[4] !== waves) {
    t3 = isLoading ? Array.from({
      length: WAVES_LIMIT
    }).map(_temp2) : waves?.map(_temp3);
    $[3] = isLoading;
    $[4] = waves;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <section className="-tw-mx-8 tw-py-10 md:tw-py-16 tw-pl-4 tw-pr-0 md:tw-px-6 lg:tw-px-8"><div className="tw-px-8">{t2}<div className="-tw-mx-6 tw-flex tw-gap-4 tw-overflow-x-auto tw-scroll-smooth tw-px-6 tw-pb-2 tw-scrollbar-none md:-tw-mx-8 md:tw-px-8 lg:tw-grid lg:tw-grid-cols-3 lg:tw-gap-5 lg:tw-overflow-visible lg:tw-pb-0">{t3}</div></div></section>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp3(wave) {
  return <div key={wave.id} className="tw-w-[80%] tw-shrink-0 sm:tw-w-80 lg:tw-w-full"><ExploreWaveCard wave={wave} /></div>;
}
function _temp2(_, index) {
  return <div key={`skeleton-${index}`} className="tw-w-[80%] tw-shrink-0 sm:tw-w-80 lg:tw-w-full"><ExploreWaveCardSkeleton /></div>;
}
async function _temp() {
  return await commonApiFetch({
    endpoint: "waves-overview",
    params: {
      type: "RECENTLY_DROPPED_TO",
      limit: String(WAVES_LIMIT),
      offset: "0"
    }
  });
}